import React from 'react'
import { CheckboxContainer, StyledHiddenCheckbox, StyledCheckbox, StyledIcon, StyledLabel } from './styled'

const CheckBox = ({ name, checked, label, noMargin, disabled, flexEnd, onClick }) => {
    return (
        <CheckboxContainer noMargin={noMargin} disabled={disabled} flexEnd={flexEnd}>
            <StyledHiddenCheckbox name={name} checked={checked} onChange={onClick} />
            <StyledCheckbox active={checked}>
                <StyledIcon viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12" />
                </StyledIcon>
            </StyledCheckbox>
            <StyledLabel>
                {
                    label
                }
            </StyledLabel>
        </CheckboxContainer>
    )
}

export default CheckBox